import { useCallback, type ReactElement } from "react";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { useScoringRuleWizardStore } from "app/pages/sales-intelligence/modules/lead-scoring-agent/store/useScoringRuleWizardStore";
import type LeadScoreFilterModel from "app/pages/sales-intelligence/modules/leads-search-filters/models/LeadScoreFilter/LeadScoreFilterModel";
import { addLeadScoreSelection } from "app/pages/sales-intelligence/modules/leads-search-filters/models/LeadScoreFilter/leadScoreFilterValue";

import { LeadScoreFilterView } from "./LeadScoreFilterView";

const LeadScoreFilter = (props: IFilterViewBaseProps<LeadScoreFilterModel>): ReactElement => {
    const { value, onFilterUpdate } = props;
    const openScoringRuleWizard = useScoringRuleWizardStore((state) => state.open);

    // Write-back stays here, where the filter's `value`/`onFilterUpdate` live. The page-root host owns the
    // wizard modal (see ScoringRuleWizardHost) — the filter only signals intent, which breaks the import cycle.
    const handleAddRule = useCallback(
        (priority: LeadPriorityScore) => {
            openScoringRuleWizard(priority, (createdPriority) => {
                onFilterUpdate(addLeadScoreSelection(createdPriority, value));
            });
        },
        [openScoringRuleWizard, onFilterUpdate, value],
    );

    return (
        <LeadScoreFilterView
            {...props}
            onAddRule={handleAddRule}
        />
    );
};

export default LeadScoreFilter;
